import { render, staticRenderFns } from "./MadrillasWithInseminationPending.vue?vue&type=template&id=45f2418a"
import script from "./MadrillasWithInseminationPending.vue?vue&type=script&lang=js"
export * from "./MadrillasWithInseminationPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports